/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:17:55
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare ખોલો",
    name2: "આરક્ષણ બનાવો",
    name3: "Carlcare સાથે, તમે કોઈપણ સમયે તમારા ઓર્ડરને ચકાસી શકો છો.",
    name4: "",
    name5: "જમણી તરફ સ્લાઇડ કરો",
    name6: "ચકાસણી પૂરી",
  },
  order: {
    name1: "ઉપકરણ મોડેલ પસંદ કરો",
    name2: "ભૂલનું વર્ણન:",
    name3: "સેવા સ્ટોર પસંદ કરવા માટે ટેપ કરો",
    name4: "સેવા સ્ટોર:",
    name5: "આરક્ષણ સમય:",
    name6: "કૃપા કરીને તમારા ઉપકરણની સમસ્યાનું વિગતવાર વર્ણન કરો!",
    name7: "આગમન સમય પસંદ કરવા માટે ટેપ કરો",
    name8: "કૃપા કરી તમારી સાચી સંપર્કની વિગતો દાખલ કરો જેથી અમે તમને પહોંચી શકીએ",
    name9: "ઉપલબ્ધ આરક્ષણ સમય નીચે મુજબ છે",
    name10: "તમારો ફોન નંબર દાખલ કરો",
    name11: "કિંમત",
    name12: "ક્તિગત માહિતી:",
    name13: "કૃપા કરીને તમારું નામ દાખલ કરો",
    name14: "રજુ કરો",
    name15: "રદ્દ કરો",
    name16: "ઓકે",
  },
  shops: {
    name1: "તમે પસંદ કરેલા બ્રાંડના આધારે, નીચેના સ્ટોર્સ તમારી સેવા આપી શકે છે!",
    name2: "વધુ છૂટક દુકાનોમાં ટૂંક સમયમાં આવી રહ્યું છે! અમારી સાથે રહો!",
  },
  price: {
    name1: "બ્રાન્ડ",
    name2: "મોડેલ",
    name3: "આઈટમ",
    name4: "કિંમત",
    name5: "મૈત્રીપૂર્ણ યાદી:",
    name6: "આ કિંમતો ફક્ત સંદર્ભ માટે છે અને વાસ્તવિક કિંમત તમારા ઉપકરણની સ્થિતિને આધિન છે.",
    name7: "જો ત્યાં કોઈ વિશેષ પ્રતીક ન હોય તો, પ્રાઈસ એકમ એ સ્થાનિક ચલણ એકમ છે.",
    name8: "ક્ષમા કરશો! વર્તમાન ક્ષેત્રમાં કોઈ કિંમતની માહિતી ઉપલબ્ધ નથી.",
    name11:"મજૂરી ખર્ચ",
    name12:"કુલ કિંમત",
    name13: "5. જો મજૂરી ખર્ચ \"/\" હોય તો, તેનો અર્થ છે કે સ્ટોરમાં મજૂરી ખર્ચ સંબંધી સલાહ લેવી જરૂરી છે.",
    item_main_board: "મેઇનબોર્ડ",
    item_screen_frame: "સ્ક્રીન (ફ્રેમ)",
    item_screen_screen_frame: "ગૌણ સ્ક્રીન (ફ્રેમ)",
    item_touch_screen: "ટચ સ્ક્રીન",
    item_camera: "\"કૅમેરો\"",
    item_fixed_focus_camera: "નિશ્ચિત ફોકસ કેમેરા",
    item_auto_focus_camera: "ઑટો ફોકસ કેમેરા",
    item_screen: "સ્ક્રીન",
    item_secondary_screen: "ગૌણ સ્ક્રીન",
    item_fingerprint_module: "ફિંગરપ્રિન્ટ મોડ્યુલ",
    item_speaker: "સ્પીકર",
    item_receiver: "પ્રાપ્તકર્તા",
    item_small_board: "નાનું બોર્ડ",
    item_battery_cover: "બૅટરી કવર",
    item_battery: "બૅટરી",
    item_charger: "ચાર્જર",
    item_usb_cable: "USB કેબલ",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "કોઈ ડેટા નથી",
    name2: "સેવા આપનાર:",
    name3: "સેવા બ્રાંડ:",
    name4: "ટેલિફોન:",
    name5: "ઓર્ડરની માત્રા:",
    name6: "સેવા રેટિંગ",
    name7: "સેવા પર્યાવરણ:",
    name8: "સેવાનું વલણ:",
    name9: "સેવા કાર્યક્ષમતા:",
    name10: "સેવા ગુણવત્તા:",
    name11: "ગ્રાહક મૂલ્યાંકન",
    name12:"થી",
    name13:"બંધ",
  },
  reserSuccess: {
    // name1:
    //   "Carlcare ખોલો",
    name1: "કૃપા કરીને આરક્ષણ માહિતીને સ્ક્રીનશોટ કરો અને અગ્રતા સેવાને ઍક્સેસ કરવા માટે તેને રસીદ તરીકે સાચવો.",
    name2: "સફળતાપૂર્વક રજુ થયું",
    name3: "1. ડેટા સાફ કરો",
    name4: "કૃપા કરીને અગાઉથી તમારા ફોન પર મહત્વપૂર્ણ ખાનગી ડેટાનો બેક અપ લો",
    name5: "2. પાવર-ઓન પાસવર્ડ અક્ષમ કરો",
    name6: "સર્વિસ સ્ટોર પર જતા પહેલાં, કૃપા કરીને:",
    name7: "સેવા સ્ટોર:",
    name8: "આરક્ષણ સમય:",
    name9: "ભૂલનું વર્ણન:",
    name10: "ઉપકરણ મૉડેલ:",
    name11: "ઓર્ડર નંબર:",
    name12: "ઓર્ડર માહિતી",
  },
  title: {
   
    name1: "નીચેના દેશોને સમર્થન આપે છે:",
    name2: "મોડેલ પસંદ કરો",
    name3: "આરક્ષણ",
    name4: "સેવા સ્ટોર વિગતો",
    name5: "સેવા સ્ટોર પસંદ કરો",
  },
  error: {
    
    name1: "કોઈ ડેટા નથી. કૃપા કરીને તમારી રિપેર માહિતી તપાસો",
    name2: "વધુ સહાયની જરૂર છે? અમારો સંપર્ક કરો.",
    name3: "માફ કરશો, વર્તમાન ક્ષેત્રમાં કોઈ Carlcare કેન્દ્ર નથી.",
    name4: "કૃપા કરીને સૌ પ્રથમ સેવા કેન્દ્ર પસંદ કરો",
    name5: "નિષ્ફળ",
    name6: "કૃપા કરીને પહેલા ઉપકરણ મોડેલ પસંદ કરો",
    name7: "વિગતો",
    name8: "કૃપા કરીને તમારી જરૂરિયાતોનું વિગતવાર વર્ણન કરો",
    name9: "",
  },
  add1:{
    "name0": "gu-rIN",
    "name1": "તમારા ઓર્ડરની પુષ્ટિ કરવામાં આવી છે. અમે તમારા આગમનની રાહ જોઈ રહ્યા છીએ.",
    "name2": "શહેર પસંદ કરો",
    "name3": "નો ફોન નંબર ઇનપુટ કરો%1$s અંકો.",
    "name4": "અઠવાડિયાના દિવસના કલાકો",
    "name5": "સોમવાર",
    "name6": "માગળવાર",
    "name7": "બુધવાર",
    "name8": "ગુરુવાર",
    "name9": "શુક્રવાર",
    "name10": "શનિવાર",
    "name11": "રવિવાર",
    "name12": "દેશ દાખલ કરો અને શોધો"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "અન્ય",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"રિડિરેક્ટ કરવા માટે ટૅપ કરો",
    name3:"ઑર્ડરને રેટ કરવા માટે Carlcare ઍપ્લિકેશન ખોલો",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"સેવા પસંદ કરો",
    name7:"નિઃશુલ્ક સફાઇ",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "ખોટી માહિતી",
    "cancelReason1": "સમયસર પહોંચી શકતા નથી",
    "cancelReason2": "ડુપ્લિકેટ ઓર્ડર/મારો ઓર્ડર નથી",
    "cancelReason3": "નિષ્ફળતા ફરી આવતી નથી",
    "cancelReason4": "માત્ર ટેસ્ટ/પૂછપરછ/ઇવેન્ટ",
    "cancelReason5": "ઊંચી કિંમત",
    "cancelReason6": "સામગ્રીની અછત",
    "cancelReason7": "કોઈ ભિન્ન સેવાઓ નથી",
    "cancelReason8": "સ્ટોર ખૂબ દૂર છે",
    "cancelReason9": "સ્ટોર બંધ છે",
    "cancelReason10": "ખરાબ સેવા વલણ",
    "cancelReason11": "અન્ય બ્રાન્ડ માટે રિપ્લેસમેન્ટ/સમારકામ",
    "cancelReason12": "સ્ટોર શોધી શકતા નથી",
    "cancelReason13": "અન્ય",
    "cancelOrder": "ઑર્ડર રદ કરો",
    "reason_dialog_title": "કૃપા કરીને અમને રદ કરવાનું કારણ જણાવો",
    "Cancel": "રદ્દ કરો",
    "OK": "ઓકે",
    "name1": "ચકાસણી કોડ દાખલ કરો",
    "name2": "અમાન્ય ચકાસણી કોડ",
    "repair_reservation_detail_canceled": "આ ઓર્ડર રદ કરવામાં આવ્યો છે!",
    "purchase_cancel_dialog_content": "શું તમે આ ઑર્ડર રદ કરવાની પુષ્ટિ કરો છો?",
    "yes": "\"હા\"",
    "no": "\"નહીં\""
}
};
